import { Shark } from "shark-mvc";

import  { Driver } from "Models/Driver";
import { driverManager } from "Managers/driverManager";

import templateContent from "Templates/views/vehicle-return.html";
import { refuelEditView } from "./refuelEditView";
import { mainNavComponent } from "../../components/mainNav/mainNavComponent";

var vehicleReturnView = Shark.createJaw("vehicleReturnView");

vehicleReturnView.templateContent = templateContent;
vehicleReturnView.route = "vehicle-pickup";

vehicleReturnView.addMethod("init", function () {
    this.addComponents([mainNavComponent]);
});

// vehicleReturnView.addMethod("newRefuelBtn_clickHandler", function () {
//     Shark.openPage(refuelEditView);
// });


Shark.registerView(vehicleReturnView);

export { vehicleReturnView };
